import React, { Component } from "react";
import Container from "@material-ui/core/Container";
import Toolbar from "../Menu/Toolbar";
import SideDrawer from "../Menu/SideDrawer";
import BackDrop from "../Menu/BackDrop";
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
//import useStyles from "../SignUp/FormStyle";

class SearchSettings extends Component {
    constructor(props) {
        super(props);
        this.state={
            menuOpen: false,
            userDate:"",
        }
      };
    
    async componentWillMount()  {
        this.setState({userData :this.props.location.state.user});
    }
    menuClickHandler = () => {
        this.setState((prevState) => {
          return { menuOpen: !prevState.menuOpen };
        });
    };

    backDropClickHandler = () => {
        this.setState({ menuOpen: false });
    };

    backDropClickHandler = () => {
        this.setState({ menuOpen: false });
    };

    render() {
        const {classes} = this.props;
        return(
            <Container component="main" maxWidth="xs">
                {/* <SideDrawer closeMenu={this.backDropClickHandler} userData ={this.props.location.state.user}/>
                <BackDrop click={this.backDropClickHandler} /> 
                <Toolbar drawerClickHandler={this.menuClickHandler} textPage="שנה אפשרויות חיפוש"/>
                */}
                {ShowSlider(this.state.userData.search_range, classes)}

            </Container>
        );
    }
} export default SearchSettings;

function ShowSlider(init_value, classes){
    const useSliderStyles = makeStyles(theme => ({
        root: {
          width: 300,
        },
        margin: {
          height: theme.spacing(3),
        },
      }));
      
      const marks = [
        {
          value: 0,
          label: '0',
        },
        {
          value: 50,
          label: '50',
        },
        {
          value: 100,
          label: '100',
        },
      ];
      
      function valuetext(value) {
        return `${value}km`;
      }
      return(
        <div>
            <div >
            טווח חיפוש
            </div>
            <p></p>
            <Slider name="range_slider" defaultValue={init_value} min= {0} max={100} getAriaValueText={valuetext}
                aria-labelledby="discrete_slider" step={1} marks={marks} valueLabelDisplay="on"/>
          </div>
      );
}